import { render, staticRenderFns } from "./BaseProductGrid.vue?vue&type=template&id=12d69ff7&"
import script from "./BaseProductGrid.vue?vue&type=script&lang=js&"
export * from "./BaseProductGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/lucia/proyectos/byl_salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12d69ff7')) {
      api.createRecord('12d69ff7', component.options)
    } else {
      api.reload('12d69ff7', component.options)
    }
    module.hot.accept("./BaseProductGrid.vue?vue&type=template&id=12d69ff7&", function () {
      api.rerender('12d69ff7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseProductGrid.vue"
export default component.exports